var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnbStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / onb-step-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "80.1931052%",
    y1: "30.5980575%",
    x2: "28.260172%",
    y2: "86.6200523%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.7792457,9.38368941 L15.0540589,73.7514789 C14.5763218,74.1925841 14.022269,74.5451631 13.4178477,74.7908999 L0,80.2642684 L6.4960027,67.3546894 C6.78752913,66.7746894 7.18284509,66.2511631 7.66058213,65.8100578 L77.385769,1.44379467 C79.5882436,-0.589257959 83.0285608,-0.459521117 85.0707722,1.73379467 C87.1129835,3.92558415 86.9817203,7.35216309 84.7792457,9.38368941 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.9%",
    y: "-16.8%",
    width: "138.1%",
    height: "141.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "54.858885%",
    x2: "60.2740596%",
    y2: "70.0422283%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83BFFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8BF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.000012,36.25 L0,36.25 L36.250015,0 L36.250015,29 C36.250015,32.9867368 32.9867505,36.25 29.000012,36.25 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-42.8%",
    y: "-37.2%",
    width: "191.0%",
    height: "191.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.6140693%",
    y1: "15.1651008%",
    x2: "65.6625782%",
    y2: "102.272037%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.934242,124.503105 L53.6408644,133.599947 C47.4379144,136.130579 41.4135435,129.614737 44.4249658,123.630053 L55.2602861,102.087632 C56.137918,100.324737 57.3421817,98.7388947 58.815077,97.3942105 L108.750045,51.2933684 L108.750045,7.25 C108.750045,3.24647368 105.50357,0 101.500042,0 L54.3750226,0 C50.3714946,0 47.1250196,3.24647368 47.1250196,7.25 L47.1250196,39.875 C47.1250196,43.8785263 43.8785445,47.125 39.8750166,47.125 L7.25000301,47.125 C3.24647503,47.125 0,50.3714737 0,54.375 L0,137.75 C0,141.753526 3.24647503,145 7.25000301,145 L101.500042,145 C105.50357,145 108.750045,141.753526 108.750045,137.75 L108.750045,95.6648947 L80.9115599,121.366526 C79.4035593,122.740211 77.7459796,123.781158 75.934242,124.503105 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.3%",
    y: "-9.3%",
    width: "130.3%",
    height: "122.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "56.9004782%",
    x2: "60.1747918%",
    y2: "78.4635173%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5324059%",
    y1: "46.5446366%",
    x2: "50%",
    y2: "81.3308427%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.648859,106.938263 L35.1831199,117.811737 L16.3117436,117.811737 C13.3094792,117.811737 10.8750045,115.377263 10.8750045,112.375 C10.8750045,109.371211 13.3094792,106.938263 16.3117436,106.938263 L40.648859,106.938263 Z M56.0005496,85.1867368 L51.4368635,89.3993684 C49.3488626,91.3118421 47.6500724,93.5891053 46.2534929,96.0617368 L16.3117436,96.0617368 C13.3094792,96.0617368 10.8750045,93.6272632 10.8750045,90.625 C10.8750045,87.6212105 13.3094792,85.1867368 16.3117436,85.1867368 L56.0005496,85.1867368 Z M79.5638225,63.4382632 L67.782186,74.3132632 L16.3117436,74.3132632 C13.3094792,74.3132632 10.8750045,71.8787895 10.8750045,68.8765263 C10.8750045,65.8712105 13.3094792,63.4382632 16.3117436,63.4382632 L79.5638225,63.4382632 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.6%",
    y: "-24.8%",
    width: "148.0%",
    height: "160.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-onb-step-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(58.479287, 39.618679)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.305267,34.6945841 L86.5207126,3.76725747 L-9.12480898,74.7675736 C-11.906121,85.5741445 -4.97087375,87.4063761 11.6809328,80.2642684 C28.3327394,73.1221606 52.5408508,57.9322659 84.305267,34.6945841 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-9)",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.750045,53.1315087 L108.750045,28.099557 L0,143.138663 C55.8482235,151.521662 92.0982385,152.142108 108.750045,145 C125.401852,137.857892 125.401852,107.235062 108.750045,53.1315087 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-13)",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-14)",
    xlinkHref: "#path-15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnbStep1);
export default __webpack_public_path__ + "static/media/onb-step-1.1e89e738bf5e710971d5cebbec520b25.svg";
export { ForwardRef as ReactComponent };